<template>
  <section>
    <div class="pt8 pb16" v-show="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="item in items" :key="item" class="fz14 cd4 lh20">
          {{ item }}
        </el-breadcrumb-item>
      </el-breadcrumb>
      <slot>
        <div v-if="description" class="mt16 con_fzb">
          <router-link v-if="back" :to="{ name: back }">
            <i :class="icon"></i>
          </router-link>
          <span>{{ description }}</span>
        </div>
      </slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeaderBoard',

  props: {
    title: String,
    items: {
      type: Array,
      default: () => [],
    },
    description: {
      type: String,
      default: '',
    },
    back: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover {
  color: #1e1f23 !important;
}

.lh20 {
  line-height: 20px;
}
</style>
